export default{
    pdf: {extensao:'pdf', valor: 'application/pdf'},
    txt: {extensao:'txt', valor: 'text/plain'},
    xls: {extensao: 'xls', valor: 'application/vnd.ms-excel'},
    xlsx: {extensao: 'xlsx', valor: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
    xml: {extensao: 'xml', valor: 'application/xml'}
}
